import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthEffects, CommonDashboardComponent, EagerLoadingDataEffects, LoginComponent, PageNotFoundComponent, authReducer, dynamicEagerLoadingReducer, staticEagerLoadingReducer } from '@app/modules/others';
import { CustomSnackbarModule, FormControlErrorDirectivesModule, LayoutModule } from '@app/shared';
import { ApiPrefixInterceptor, SuccessErrorHandlerInterceptor } from '@app/shared/services';
import { MsalInterceptor, MsalModule } from '@azure/msal-angular';
import { JobSelectionScanModalModule } from '@modules/inventory';
import { ScheduleCallbackViewModalModule } from '@modules/sales/components/lead-notes/schedule-callback-view-modal.module';
import { RebookSnoozeModalModule } from '@modules/technical-management/components/rebook-snooze';
import { TechnicianInspectionSnoozeModalModule } from '@modules/technical-management/components/technitian-inspection-snooze/technician-inspection-snooze-modal.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { MessageService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { WindowRefService } from '../app/modules/others/non-crm/components/remote-acceptance/components/window-service';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { metaReducers, reducers } from './reducers';
import { ExcelExportService } from './shared/services/excel-export.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { VersionDetailsComponent } from '@modules/others/version-details/version-details.component';
// import { AllPipesModule } from "./shared/pipes/all-pipes.module";
@NgModule({
    declarations: [
        AppComponent,
        PageNotFoundComponent,
        CommonDashboardComponent,
        LoginComponent,
        VersionDetailsComponent
    ],
    providers: [Title, MessageService, ExcelExportService, DeviceDetectorService,
        {
            provide: HTTP_INTERCEPTORS,
            multi: true,
            useClass: ApiPrefixInterceptor
        },
        {
            provide: HTTP_INTERCEPTORS,
            multi: true,
            useClass: SuccessErrorHandlerInterceptor
        },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        WindowRefService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule, CommonModule, AppRoutingModule, ScheduleCallbackViewModalModule,
        BrowserAnimationsModule, HttpClientModule, TechnicianInspectionSnoozeModalModule,
        RebookSnoozeModalModule, JobSelectionScanModalModule,
        FormsModule, ReactiveFormsModule, CustomSnackbarModule,
        LayoutModule, MessagesModule, ProgressSpinnerModule, FormControlErrorDirectivesModule,
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true,
            }
        }), StoreModule.forFeature('auth', authReducer),
        StoreModule.forFeature('staticEagerLoadingData', staticEagerLoadingReducer),
        StoreModule.forFeature('dynamicEagerLoadingData', dynamicEagerLoadingReducer),
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
        EffectsModule.forRoot([]),
        EffectsModule.forFeature([AuthEffects, EagerLoadingDataEffects]),
        ProgressSpinnerModule,
        MsalModule.forRoot({
            auth: {
                clientId: environment.MSALClientId,
                authority: "https://login.microsoftonline.com/" + environment.MSALTenantId,
                validateAuthority: true,
                redirectUri: environment.redirectUrl,
                postLogoutRedirectUri: environment.postLogoutRedirectUri,
                navigateToLoginRequestUrl: false,
            },
            cache: {
                cacheLocation: 'sessionStorage'
            },
        }),
        // AllPipesModule
    ]
})

export class AppModule { }
